import gql from 'graphql-tag';
import React, { SFC, useEffect, useState } from 'react';
import styled from '../../styled-components';
import { VideoContentBlockFragment } from '../../entities/operationResults';
import Container from '../atoms/Container';
import ReactPlayer from 'react-player';

export const fragment = gql`
    fragment VideoContentBlock on video_Entry {
        videoUrl
    }
`;

interface Props {
    contentBlock: VideoContentBlockFragment;
}

const VideoContentBlock: SFC<Props> = ({ contentBlock: { videoUrl } }) => {
    const [hasMarketingConsent, setHasMarketingConsent] = useState(false);

    const checkConsent = () => {
        if (typeof window !== 'undefined' && window.Cookiebot) {
            setHasMarketingConsent(!!window.Cookiebot.consent.marketing);
        }
    };

    useEffect(() => {
        checkConsent();

        window.addEventListener('CookiebotOnConsentReady', checkConsent);
        window.addEventListener('CookiebotOnAccept', checkConsent);
        window.addEventListener('CookiebotOnDecline', checkConsent);

        return () => {
            window.removeEventListener('CookiebotOnConsentReady', checkConsent);
            window.removeEventListener('CookiebotOnAccept', checkConsent);
            window.removeEventListener('CookiebotOnDecline', checkConsent);
        };
    }, []);

    return (
        <Container maxWidth paddingBottom="6rem" paddingBottomL="8rem">
            <Wrapper>
                {hasMarketingConsent && (
                    <ReactPlayer
                        width="100%"
                        height="100%"
                        className="react-player"
                        url={videoUrl || ''}
                        config={{
                            youtube: {
                                playerVars: { modestbranding: 1 },
                                embedOptions: {
                                    host: 'https://www.youtube-nocookie.com',
                                },
                            },
                        }}
                    />
                )}
            </Wrapper>
        </Container>
    );
};

const Wrapper = styled.div`
    position: relative;
    padding-top: 56.25%;
    .react-player {
        position: absolute;
        top: 0;
        left: 0;
    }
`;

export default VideoContentBlock;